import { useEffect, useState } from "react";

/** Phones only: on a wide screen the bubble sits in the margin, not over the content. */
const PHONE_QUERY = "(max-width: 47.99rem)";
/** A scroll this small is a finger resting, not a direction. */
const MIN_DELTA = 6;

/**
 * SOHBET DÜĞMESİ TELEFONDA İÇERİĞİ ÖRTÜYORDU — 7 Ekim 2026, kullanılabilirlik turu.
 *
 * 56 piksellik yuvar düğme sağ altta sabit; sayfanın SONU için kabuk zaten boşluk bırakıyor
 * (`--launcher-reserve`), ama okunan satır her zaman sayfanın sonu değil: Belgelerim'in boş durum
 * cümlesi, Panelim'deki «Takvimde gör», bir kutucuğun oku düğmenin altında kalıyordu.
 *
 * Telefonda bilinen kalıp: aşağı kaydırırken düğme çekilir, yukarı kaydırınca ya da sayfanın
 * sonuna gelince geri gelir (sonda kabuğun boşluğu var, örtecek bir şey yok). Adres değişince de
 * geri gelir. Panel açıkken hiç saklanmaz.
 *
 * Kaydıran öğe `<main id="main">` (`MainScroller`), pencere değil.
 */
export function useLauncherScrollAway(input: { enabled: boolean; pathname: string }): boolean {
  const { enabled, pathname } = input;
  const [away, setAway] = useState(false);

  useEffect(() => {
    setAway(false);
    if (!enabled || typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return;
    }
    const scroller = document.getElementById("main");
    if (!scroller) return;
    const phone = window.matchMedia(PHONE_QUERY);
    let last = scroller.scrollTop;

    const onScroll = () => {
      const top = scroller.scrollTop;
      const delta = top - last;
      if (!phone.matches) {
        last = top;
        setAway(false);
        return;
      }
      if (Math.abs(delta) < MIN_DELTA) return;
      last = top;
      const atEnd = top + scroller.clientHeight >= scroller.scrollHeight - MIN_DELTA;
      setAway(delta > 0 && !atEnd);
    };

    scroller.addEventListener("scroll", onScroll, { passive: true });
    return () => scroller.removeEventListener("scroll", onScroll);
  }, [enabled, pathname]);

  return enabled && away;
}
